import { render, staticRenderFns } from "./SysNoticeList.vue?vue&type=template&id=fab7d142&scoped=true&"
import script from "./SysNoticeList.vue?vue&type=script&lang=js&"
export * from "./SysNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab7d142",
  null
  
)

export default component.exports